import { useAtom } from 'jotai';
import {
  accStatementDemoModeAtom,
  assistDemoModeAtom,
  auditDemoModeAtom,
  demoModeAtom,
  easyDemoModeAtom,
  reportDemoModeAtom,
  translateDemoModeAtom,
} from '@/global-store';

export type BadgeShowWhen =
  | 'always'
  | 'reportDemoMode'
  | 'accStatementDemoMode'
  | 'auditDemoMode'
  | 'assistDemoMode'
  | 'translateDemoMode'
  | 'easyDemoMode';

export type NavTitleBadge = {
  text?: string;
  showWhen?: BadgeShowWhen;
};

export function useBadgeVisibility(badge?: NavTitleBadge) {
  const [reportDemoMode] = useAtom(reportDemoModeAtom);
  const [accStatementDemoMode] = useAtom(accStatementDemoModeAtom);
  const [assistDemoMode] = useAtom(assistDemoModeAtom);
  const [auditDemoMode] = useAtom(auditDemoModeAtom);
  const [easyDemoMode] = useAtom(easyDemoModeAtom);
  const [translateDemoMode] = useAtom(translateDemoModeAtom);
  const [generalDemoMode] = useAtom(demoModeAtom);

  if (!badge?.showWhen) return false;

  if (badge.showWhen === 'always') return true;
  if (generalDemoMode) return false;

  const demoModeMap: Record<Exclude<BadgeShowWhen, 'always'>, boolean> = {
    reportDemoMode,
    accStatementDemoMode,
    auditDemoMode,
    assistDemoMode,
    translateDemoMode,
    easyDemoMode,
  };

  return Boolean(demoModeMap[badge.showWhen]);
}
